import React, { useState } from 'react';
import { Text, View, Image, Pressable, Keyboard, Platform } from 'react-native';
import classes from '../../../../styles/globalClasses';
import gs from '../../../../styles/globalStyles';
import OTPVerification from '@sharedComponents/OTPInput/OTPInput';
import axios from 'axios';
import { X } from '@sharedComponents/Icons';
import { endpoints } from '@api/apis';
import { Typography } from '@app/sharedComponents/typography/Typography';
import { ColorTokens, FontFamilyTokens, FontSizeTokens, TypographyTypeDLS } from '@voltmoney/schema';
import { getParameters } from '@app/utils';
import {useDarkMode} from '@app/utils';
import { ThemedText, ThemedView } from '@app/theme';
import useIsMobileBrowser from '@app/hooks/useIsMobileBrowser';
import { handleOtpReport } from '@app/screens/FetchPortfolio/utils';
import ReportOtp from '../../../../../assets/Icons/ReportOtp';
import Button from '@app/sharedComponents/Button/Button';

const iconUrl =
  'https://volt-images-alpha.s3.ap-south-1.amazonaws.com/icon_holder.png';
interface VerifyEmailOTPProps {
  userDetails: any;
  otpDigitCount: number;
  email: string;
  onClose: () => void;
  onEmailUpdateSuccess: () => void;
  onResendFail: (err:string) => void;
}

const VerifyEmailOTP: React.FC<VerifyEmailOTPProps> = ({
  userDetails,
  otpDigitCount,
  email,
  onClose,
  onEmailUpdateSuccess,
  onResendFail
}) => {
  const [hasError, setHasError] = useState<string>('');
  const [verifying, setVerifying] = useState<boolean>(false);
  const [isBlocked, setIsBlocked] = useState(false);
  const isDarkMode = useDarkMode()
  const [isReportingMode,setIsReportingMode] = useState(false)
  const isMobileBrowser = useIsMobileBrowser()
  
  const submitOtp = (otp: string) => {
    setVerifying(true);
    const url = endpoints.verifyEmailOTP;
    const payload = {
      emailId: email,
      otp,
    };
    axios
      .post(url, payload, { handleFromMF: true })
      .then(res => {
        onEmailUpdateSuccess();
        onClose();
      })
      .catch(err => {
        console.log('err', err);
        setHasError(err?.data?.message);
        if (
          err?.status === 400 &&
          err?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP'
        ) {
          setIsBlocked(true);
        }
      })
      .finally(() => {
        setVerifying(false);
      });
  };

  const handleOtpInput = (otp: string[]) => {
    if (isBlocked) {
      return;
    }

    const OTP = otp.join('');
    if (OTP.length === otpDigitCount) {
      submitOtp(OTP);
    } else if (OTP.length > 0 && hasError !== '') {
      setHasError('');
    }
  };


  const reportOtpIssue = async () => {
    handleOtpReport({
     payload: {
         uniqueId: email,
         uniqueIdentifierType: `ENTER_EMAIL`,
     }

 })
 }

 
  const triggerResendOTP = (): void => {
    setHasError('');
    const url = endpoints.requestEmailOTP;
    const payload = {
      borrowerAccountId: userDetails?.linkedBorrowerAccounts[0]?.accountId,
      emailId: email,
    };
    axios
      .post(url, payload)
      .then(res => {
        console.log('senOTP', res);
      })
      .catch(err => {
        setHasError(err?.data?.message);
        console.log('err', err);
        if (
          err?.status === 400 &&
          err?.data?.voltErrorCode === 'ACCOUNT_BLOCKED_FROM_OTP'
        ) {
          setIsBlocked(true);
          Keyboard.dismiss()
          onResendFail(err?.data?.message)
        }
      });
  };

  return isReportingMode? (<>
    <ThemedView alignItems='center' padding='lg'>
     <ReportOtp width={100} height={100}/>
     <ThemedText variant='h5s'>Request Received</ThemedText>
   <ThemedText textAlign='center' marginTop='sm' variant='b3r'>
   {"Thanks for the feedback, We are working on the issue, please try again shortly."}    </ThemedText>

       <Button handlePress={()=>{
         onClose()
         setTimeout(()=>{
           setIsReportingMode(false)

         },1000)
         
       }}
       overRideStyle={{marginTop:24}}
       label='Got it'
       />
     </ThemedView>
 
 </>) : (
    <>
      <View style={[gs.setPadding(16), gs.setMarginTop(8)]}>
        <View style={[gs.flexRow, gs.spaceBetween]}>
          <View
            style={[
              gs.setMarginBottom(16),
            ]}>
              <ThemedText color='text-primary' variant='h3s'>{`Enter ${otpDigitCount}-digit OTP`}</ThemedText>
          </View>
          {/* <Pressable onPress={onClose} style={{ padding: 4 }}>
            <X color={isDarkMode ? ColorTokens.White : ColorTokens.Grey_Night} size={24} />
          </Pressable> */}
        </View>

        <ThemedView
          bg='bg-fill-emphasis-secondary'
          borderColor = {isDarkMode ? '#10964833' : 'border-emphasis-secondary'}
          style={[
            gs.flexRow,
            {
              borderRadius: 12,
              borderWidth: 1,
              // borderColor: isDarkMode ? '#10964833': '#CFEADA',
              padding: 12,
            },
            gs.setMarginBottom(16),
          ]}>
          <Image source={{ uri: iconUrl }} style={{ width: 40, height: 40 }} />
          <View style={[gs.setMarginLeft(12)]}>
            <ThemedText color='text-primary' variant='b4r'>{'OTP sent to'}</ThemedText>
            <View style={{marginTop:3}}>
              <ThemedText color='text-secondary' variant='b3r'>{email}</ThemedText>
            </View>
          </View>
        </ThemedView>
        <OTPVerification
          noOfDigits={otpDigitCount}
          hasError={hasError}
          handleOtpInput={handleOtpInput}
          resendTimerCount={15}
          triggerResendOTP={triggerResendOTP}
          verifying={verifying}
          blockResend={isBlocked}
          onCustomerFacingIssue={()=>{ 
            setIsReportingMode(true)
             reportOtpIssue()
          }}
          isDarkMode={Boolean(isDarkMode)}
        />
        {isMobileBrowser && <ThemedView height={30} />}
      </View>
    </>
  );
};
export default VerifyEmailOTP;
